// Full-document render of the tempurpedic BasicPage: PageSkeleton (the React
// document shell) wrapping the existing basic-page body assembly. The legacy
// template overrode BOTH {% block header %} and {% block footer %} to empty,
// so the site header and footer are suppressed here (header/footer={false}),
// and with the header went the SiteHeader-rendered flash messages --
// messages={false} (the server skips the queue drain via
// include_messages=False to match).
import React from "react";

import { templates } from "@reactivated";

import { BasicPageBody } from "../components/BasicPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes
// PageSkeleton, which is typed with mutable reactivated props (see
// PageSkeleton). The body template accepts Immutable props, to which these
// are assignable.
type IProps = templates.BasicPageTemplate;

export const Template = (props: IProps): React.JSX.Element => (
    <PageSkeleton
        pageChrome={props.page_chrome}
        header={false}
        footer={false}
        messages={false}
    >
        <BasicPageBody
            page={props.page}
            hardcoded_ssr={props.hardcoded_ssr}
            hotspot_ssr={props.hotspot_ssr}
            breadcrumbs_ssr={props.breadcrumbs_ssr}
            customer_service_ssr={props.customer_service_ssr}
            shop_compare_ssr={props.shop_compare_ssr}
            tab_feature_attribute_ssr={props.tab_feature_attribute_ssr}
            reviews_ssr={props.reviews_ssr}
        />
    </PageSkeleton>
);
